import React, { useEffect, useRef } from 'react';

function SortPopup({ selectedSort, onSelect, onClose, t }) {
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const options = [
    { id: 'Songs A-Z', label: t ? t('songs.sortOptions.songsAZ') : 'Songs A-Z' },
    { id: 'Artists A-Z', label: t ? t('songs.sortOptions.artistsAZ') : 'Artists A-Z' },
    { id: 'Recently Added', label: t ? t('songs.sortOptions.recentlyAdded') : 'Recently Added' },
  ];

  return (
    <div className="popup-dropdown sort-dropdown" ref={containerRef}>
      <div className="popup-title">{t ? t('common.sortBy') : 'Sort By'}</div>
      <div className="popup-options">
        {options.map((opt) => (
          <button
            key={opt.id}
            className={`popup-option-btn ${selectedSort === opt.id ? 'active' : ''}`}
            onClick={() => {
              onSelect(opt.id);
              onClose();
            }}
          >
            <span>{opt.label}</span>
            {selectedSort === opt.id && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SortPopup;
